import React, { Component } from 'react';
import { Link } from "react-router-dom";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Footer from './../../components/footer';
import Flodeskform from "./../../components/flodeskForm";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class Contact extends Component {
  constructor(props) {
      super(props);
      this.state = {
      componentReady: '',
		  Name: '',
		  Email:'',
		  Phone:'',
		  Message:''
      };
  }

  componentDidMount = () => {
    setTimeout(function() {
      this.setState(
				{
					componentReady: 'ready'
				}
		);

    }.bind(this), 10);
  }
  handleChange = (e) => {
	var name = e.target.name;
    this.setState({[name]: e.target.value});
  }
  handleSubmit = (e) => {
	 e.preventDefault();
	 var url = 'https://snowday.alpine.design/utilities/form/contactform.php?'+
	 'Name='+this.state.Name+
	 '&Email='+this.state.Email+
	 '&Message='+this.state.Message+
	 '&RecipientEmail=hello@katmedina.com'+
	 '&RecipientName=Kat Medina'+
   '&SenderName='+this.state.Name+
	 '&SenderEmail='+this.state.Email+
   '&Meat='+this.state.Phone+
	 '&Success=http://www.katmedina.com/thankyou?type=contact'+
	 '&Subject=Kat Medina Contact Form'+
	 '&Source=katmedina.com';

     var xhr = new XMLHttpRequest();
	 xhr.open("POST", url, true);

	 //Send the proper header information along with the request
	 xhr.send();
	 document.getElementById('submit-button').click()

  }

  render() {
    let padding = "100px";
    if(window.outerWidth < 800){
      padding = "20px";
    }
    return (
      <div className={this.state.componentReady}>
        <Helmet>
          <title>{'Contact Kat Medina | The Joys of Jet Lag'}</title>
          <meta name="description" content="Don't be shy! Send a message to Kat Medina." />
        </Helmet>
        <BannerFadeIn>
          <div id="hero" className="hero" style={{height:"auto", overflow:"auto"}}>
            <div className="hero-content" style={{padding:padding, paddingTop:"70px",paddingBottom:"100px", minHeight:window.innerHeight}}>
              <div className="small-padding small-max-width-container" style={{maxWidth:"800px"}}>
                <div className="left-text tiny-padding">
                  <h1 className="white" style={{marginLeft:"-.5%"}}>{'Don\'t be shy'}</h1>
                  <h5 className="white">{'Unless you want to send me unsolicited photos of your baby, then yes... Feel free to be shy.'}</h5>
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="tiny-padding">
                    <input type="text" name="Name" placeholder="Name" value={this.state.Name} onChange={this.handleChange}/>
                  </div>
                  <div className="tiny-padding">
                    <input type="text" name="Email" placeholder="Email" value={this.state.Email} onChange={this.handleChange} />
                  </div>
                  <div className="tiny-padding" style={{'display':'none'}}>
                    <input type="text" name="Phone" placeholder="Phone" value={this.state.Phone} onChange={this.handleChange} />
                  </div>
                  <div className="tiny-padding">
                    <textarea type="text" name="Message" placeholder="Message" value={this.state.Message} rows="5" onChange={this.handleChange} ></textarea>
                  </div>
                  <div className="tiny-padding">
                    <input type="submit" className="primary-background white" value="Submit" style={{padding:"25px", fontWeight:"bold"}} />
                  </div>
                </form>
                <h5 className="white">{'Don\'t like contact forms? Ok, princess, take it easy. Just shoot me an email at '}<a href="mailto:hello@katmedina.com">{'hello@katmedina.com'}</a></h5>
              </div>
            </div>
            <div id="hero-background" className="hero-background" style={{backgroundImage: "url(/images/contact.jpg)", backgroundPosition:"top"}}></div>
            <Link id="submit-button" to="/thankyou?type=contact"></Link>
          </div>
        </BannerFadeIn>
        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact/index.js